var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 10.5C10.9477 10.5 10.5 10.9477 10.5 11.5V20.5C10.5 21.0523 10.9477 21.5 11.5 21.5H20.5C21.0523 21.5 21.5 21.0523 21.5 20.5V11.5C21.5 10.9477 21.0523 10.5 20.5 10.5H11.5ZM8.5 11.5C8.5 9.84315 9.84315 8.5 11.5 8.5H20.5C22.1569 8.5 23.5 9.84315 23.5 11.5V20.5C23.5 22.1569 22.1569 23.5 20.5 23.5H11.5C9.84315 23.5 8.5 22.1569 8.5 20.5V11.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3.5C4.23478 3.5 3.98043 3.60536 3.79289 3.79289C3.60536 3.98043 3.5 4.23478 3.5 4.5V13.5C3.5 13.7652 3.60536 14.0196 3.79289 14.2071C3.98043 14.3946 4.23478 14.5 4.5 14.5H5.5C6.05228 14.5 6.5 14.9477 6.5 15.5C6.5 16.0523 6.05228 16.5 5.5 16.5H4.5C3.70435 16.5 2.94129 16.1839 2.37868 15.6213C1.81607 15.0587 1.5 14.2956 1.5 13.5V4.5C1.5 3.70435 1.81607 2.94129 2.37868 2.37868C2.94129 1.81607 3.70435 1.5 4.5 1.5H13.5C14.2956 1.5 15.0587 1.81607 15.6213 2.37868C16.1839 2.94129 16.5 3.70435 16.5 4.5V5.5C16.5 6.05228 16.0523 6.5 15.5 6.5C14.9477 6.5 14.5 6.05228 14.5 5.5V4.5C14.5 4.23478 14.3946 3.98043 14.2071 3.79289C14.0196 3.60536 13.7652 3.5 13.5 3.5H4.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.4ac189e2ce4dd740b671c27f07673b2a.svg";
export { ForwardRef as ReactComponent };